import type { CouponIdentifiers } from '../../../../schema/coupon/entry.js';
import { getInstanceClient } from '../../../di/entry.browser.js';
import { PoolbettingError } from '../../../domain/entry.js';
import type { ActionResult } from '../../../lib/entry.js';

type ResetCouponArgs = CouponIdentifiers;

/**
 * Resets a given coupon board.
 *
 * @param root0 Function args
 * @param root0.couponId Unique coupon id
 * @param root0.couponIndex Unique coupon index
 * @returns response status of request
 */
export async function resetCoupon({ couponId, couponIndex }: ResetCouponArgs): Promise<ActionResult<boolean>> {
  const resetCouponController = getInstanceClient('IResetCouponController');

  try {
    const isUpdated = await resetCouponController({ couponId, couponIndex });

    return { status: 'SUCCESS', data: isUpdated };
  } catch (error) {
    if (PoolbettingError.isInstance(error)) {
      return error.toActionResult();
    }

    return { status: 'ERROR', error: 'Något gick fel' };
  }
}
